import { EventDataSet } from '../DataSet/Event';
import { IDataHandler } from '../IDataHandler';
import { allTrackingEvents } from '../TrackingEvent';
import { getDateString } from '../../DateHelper';

export class EventDataHandler<T> implements IDataHandler<EventDataSet<T>> {
    public data: EventDataSet<T> = new EventDataSet<T>();

    public getEventData(eventName: allTrackingEvents): EventDataSet<T> {
        this.data.eventName = eventName;
        this.data.eventTimestamp = getDateString();
        return this.data;
    }

    public clearData(): void {
        this.data = new EventDataSet();
    }
}
